export const AMENITIES = [
  "In-unit Washer/Dryer",
  "Air Conditioning",
  "Heating",
  "Dishwasher",
  "Parking",
  "Garage",
  "Pets Allowed",
  "Furnished",
  "Balcony / Patio",
  "Pool",
  "Gym / Fitness",
  "Elevator",
  "Hardwood Floors",
  "Walk-in Closet",
  "High-speed Internet",
  "Utilities Included",
  "Wheelchair Accessible",
  "Outdoor Space / Yard",
  "Fireplace",
  "Smart Home",
];

export const AmenityPicker = ({ value = [], onChange, testidPrefix = "amenity" }) => {
  const toggle = (a) => {
    if (value.includes(a)) onChange(value.filter((x) => x !== a));
    else onChange([...value, a]);
  };
  return (
    <div className="flex flex-wrap gap-2">
      {AMENITIES.map((a) => {
        const active = value.includes(a);
        return (
          <button
            key={a}
            type="button"
            data-testid={`${testidPrefix}-${a.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
            onClick={() => toggle(a)}
            className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${
              active ? "bg-primary text-white border-primary" : "bg-white text-foreground border-border hover:border-primary/50"
            }`}
          >
            {a}
          </button>
        );
      })}
    </div>
  );
};
